/* LSL · Fiche produit, mise en page C : bas de fiche identique à la maquette C (balisage : snippets/lsl-cb.liquid).
   - Avis : 3 avis clients d'origine (section « avis de la boutique »), ceux du produit affiché d'abord.
   - « Tout savoir » : les volets de la fiche (Description, Livraison…) et la FAQ d'origine sont déplacés ici, sans copie.
   - Comparatif : « Choisir » coche la vraie version de la fiche, et le tableau suit la version choisie.
   - Prix : ligne « ou 3× … sans frais avec Klarna » à la place du badge Klarna. */
(() => {
  'use strict';
  const root = document.querySelector('[data-lsl-cb]');
  if (!root) return;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const main = root.closest('.shopify-section') || document;
  const handle = root.dataset.handle || '';

  /* Titres en « Majuscule À Chaque Mot » remis en minuscules, comme sur la maquette (noms propres et sigles gardés) */
  const KEEP = /^(Star|Wars|Jedi|Sith|Luke|Skywalker|Vador|Dark|Kylo|Ren|Yoda|Obi|Wan|Anakin|Leia|Maul|Proffie|Proffieboard|Bluetooth|PayPal|Klarna|Stripe|Colissimo|ForcePark|Noël|France|Android|Apple|Google|Padawan)$/;
  const cap = p => /^[A-ZÀ-ÖØ-Þ][a-zà-öø-ÿ’']+$/.test(p);
  function sentence(t) {
    const w = t.trim().split(/\s+/);
    const rest = w.slice(1).filter(x => /[A-Za-zÀ-ÿ]/.test(x));
    if (!rest.length || rest.filter(x => cap(x.split('-')[0])).length / rest.length < 0.6) return t.trim();
    return w.map((x, i) => i === 0 ? x : x.split('-').map(p => cap(p) && !KEEP.test(p) ? p.toLowerCase() : p).join('-')).join(' ');
  }

  /* ---------- Avis ---------- */
  function reviews() {
    const box = $('[data-lsl-cb-revs]', root); if (!box) return;
    const noEmoji = t => t.replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{200D}]/gu, '').replace(/\s+/g, ' ').trim();
    const items = $$('.lsl-reviews [data-review-card]').map(c => {
      const a = $('.lsl-review__footer a', c);
      let path = '';
      try { path = a ? new URL(a.getAttribute('href'), location.href).pathname : ''; } catch (_) {}
      const st = $('.lsl-review__stars', c);
      const n = Math.max(1, Math.min(5, parseInt((st && st.getAttribute('aria-label')) || '5', 10) || 5));
      return {
        mine: !!handle && path.endsWith('/products/' + handle),
        n,
        q: noEmoji(($('.lsl-review__quote', c) || {}).textContent || ''),
        who: (($('.lsl-review__footer strong', c) || {}).textContent || '').trim(),
        date: (($('.lsl-review__date', c) || {}).textContent || '').trim(),
        pname: a ? a.textContent.replace(/^\s*Sur\s+/, '').replace(/[↗\s]+$/, '').trim() : '',
        url: a ? a.getAttribute('href') : ''
      };
    }).filter(x => x.q);
    const pick = items.filter(x => x.mine).concat(items.filter(x => !x.mine)).slice(0, 3);
    if (!pick.length) { box.parentElement.classList.add('lsl-cb-gone'); return; }
    const cut = t => t.length > 260 ? t.slice(0, Math.max(120, t.lastIndexOf(' ', 250))) + '…' : t;
    const stars = n => n >= 5 ? '★★★★★' : '★'.repeat(n) + '<span style="opacity:.3">' + '★'.repeat(5 - n) + '</span>';
    box.innerHTML = pick.map(x => `<figure class="mq-rev"><span class="mq-stars" role="img" aria-label="${x.n} sur 5">${stars(x.n)}</span><blockquote>« ${esc(cut(x.q))} »</blockquote><figcaption><b>${esc(x.who)}</b>${x.date ? ' · ' + esc(x.date) : ''}${!x.mine && x.pname ? ` · <a href="${esc(x.url)}">${esc(x.pname)}</a>` : ''}</figcaption></figure>`).join('');
  }

  /* ---------- Volets de la fiche ---------- */
  function accordions() {
    const box = $('[data-lsl-cb-acc]', root); if (!box) return;
    $$('.product-info details.product-info__accordion', main).forEach(d => {
      const sum = $('summary', d); const body = sum && sum.nextElementSibling;
      if (!sum || !body) return;
      const nd = document.createElement('details');
      const s = document.createElement('summary'); s.textContent = sentence(sum.textContent.replace(/\s+/g, ' '));
      const b = document.createElement('div'); b.className = 'mq-acc__body';
      while (body.firstChild) b.append(body.firstChild);
      /* Enveloppes du thème (prose, rte) retirées : le contenu s'affiche comme sur la maquette */
      let w;
      while (b.children.length === 1 && (w = b.firstElementChild).tagName === 'DIV' && /prose|rte|accordion__/.test(w.className)) { while (w.firstChild) b.insertBefore(w.firstChild, w); w.remove(); }
      nd.append(s, b); box.append(nd);
      (d.closest('.product-info__block-item') || d).classList.add('lsl-cb-gone');
    });
    if (!box.children.length) box.parentElement.classList.add('lsl-cb-gone');
  }

  /* ---------- Questions fréquentes ---------- */
  function faq() {
    const box = $('[data-lsl-cb-faq]', root); if (!box) return;
    $$('.lsl-native-faq details.lsl-native-faq__item').forEach(d => {
      const sum = $('summary', d); const a = $('.lsl-native-faq__answer', d);
      if (!sum || !a) return;
      const nd = document.createElement('details');
      const s = document.createElement('summary');
      const h = $('h3', sum);
      if (h) { h.textContent = sentence(h.textContent); s.append(h); } else s.textContent = sentence(sum.textContent);
      const b = document.createElement('div'); b.className = 'mq-acc__body';
      while (a.firstChild) b.append(a.firstChild);
      nd.append(s, b); box.append(nd);
    });
    if (!box.children.length) box.parentElement.classList.add('lsl-cb-gone');
  }

  /* ---------- Comparatif relié au vrai choix de version ---------- */
  function versions() {
    const picks = $$('[data-lsl-ov]', root); if (!picks.length) return;
    const input = id => main.querySelector(`input[type="radio"][value="${id}"]`);
    function sync() {
      let key = '';
      picks.forEach(b => { const i = input(b.dataset.lslOv); if (i && i.checked) key = b.dataset.mqVariant; });
      if (!key) return;
      picks.forEach(b => { const on = b.dataset.mqVariant === key; b.setAttribute('aria-pressed', String(on)); b.textContent = on ? 'Ta version' : 'Choisir'; });
      $$('[data-mq-col]', root).forEach(e => e.classList.toggle('is-sel', e.dataset.mqCol === key));
      document.documentElement.dataset.version = key;
    }
    root.addEventListener('click', e => {
      const b = e.target.closest('[data-lsl-ov]'); if (!b) return;
      const i = input(b.dataset.lslOv);
      if (i && !i.checked) ((i.labels && i.labels[0]) || i).click();
      setTimeout(sync, 60);
    });
    document.addEventListener('change', e => { if (e.target.matches && e.target.matches('input[type="radio"]')) setTimeout(sync, 0); });
    /* Le thème ou Kaching peuvent changer de version sans événement « change » (version mémorisée, lien ?variant=) : on resynchronise quand le bloc d'achat bouge */
    const pi = main.querySelector('.product-info');
    if (pi) { let raf = 0; new MutationObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }).observe(pi, { subtree: true, childList: true, characterData: true }); }
    sync(); setTimeout(sync, 1500);
  }

  /* ---------- Paiement en plusieurs fois sous le prix (remplace le badge Klarna, comme sur la maquette) ---------- */
  function klarna() {
    const pi = main.querySelector('.product-info'); if (!pi) return;
    const count = () => {
      const k = document.querySelector('klarna-placement');
      const m = k && k.shadowRoot && k.shadowRoot.textContent.match(/(\d+)\s+paiements/);
      return m ? +m[1] : 3; /* offre Klarna de la boutique : 3 paiements à 0 % */
    };
    const upd = () => {
      const pr = pi.querySelector('.product-info__price sale-price'); if (!pr) return;
      const host = pr.closest('price-list') || pr;
      let x = pi.querySelector('.lsl-cb-x4');
      if (!x) { x = document.createElement('span'); x.className = 'lsl-cb-x4'; }
      if (host.nextElementSibling !== x) host.after(x);
      const cents = Math.round(parseFloat(pr.textContent.replace(/[^\d,]/g, '').replace(',', '.')) * 100);
      const n = count();
      const t = cents >= 3500 ? `ou ${n}× ${(Math.round(cents / n) / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} € sans frais avec Klarna` : '';
      if (x.textContent !== t) x.textContent = t;
      x.hidden = !t;
    };
    let raf = 0;
    new MutationObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(upd); }).observe(pi, { subtree: true, childList: true, characterData: true });
    upd(); setTimeout(upd, 3000);
  }

  const run = () => { reviews(); accordions(); faq(); versions(); klarna(); root.classList.add('is-ready'); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
